import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import * as api from '../../services/api';
import Select2 from '../../../components/shared/select2';
import * as blockui from '../../../helpers/block-ui';
import * as swal from '../../../helpers/swal';

export default {
  props: {
    user: {
      default() {
        return {};
      },
      type: Object,
    },
    isUpdate: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      filter: {
        filterAssessment: '',
      },
    };
  },
  components: {
    select2: Select2,
  },
  computed: {
    ...mapState({
      // referenceLibraryList: state => state.reference_library.referenceLibraryList,
      // timeUnitList: state => state.unit.timeUnitList,
      userAssessmentList: (state) => state.training.userAssessmentList,
      assessmentList: (state) => state.training.assessmentList,
      userList: (state) => state.user.userList,
    }),
    ...mapGetters({
      getDocumentStatusText: 'getDocumentStatusText',
      getDocumentValidityStatusText: 'getDocumentValidityStatusText',
    }),
  },
  created() {
    const self = this;
    self.$store.commit('setUserAssessmentFilter', {});
  },
  async mounted() {
    const self = this;
    self.$store.dispatch('getAssessmentList');
    self.$store.dispatch('getUserList');

    await self.initData();
    // self.$store.dispatch('getReferenceLibraryList', {deviceId: self.user.Id});

    /* self.$store.dispatch('getTimeUnitList');
    self.$store.dispatch('getDocumentStatuses');
    self.$store.dispatch('getDocumentValidityStatuses'); */
    mApp.initScrollers();
  },
  methods: {
    deleteItem(index) {
      const self = this;
      const id = self.userAssessmentList[index].Id;
      const name = self.userAssessmentList[index].Name;
      swal.check(self, name).then((e) => {
        if (e.value) {
          api.deleteUserAssessment(id).then((response) => {
            if (response.body.IsSuccess) {
              toastr.success(self.translate('delete_successfully'));
              self.initData();
            } else {
              toastr.error(response.body.Message);
            }
          });
        }
      });
    },
    editItem(index) {
      this.$parent.$parent.editItem('userAssessment', this.userAssessmentList[index].Id);
    },
    async initData() {
      const self = this;
      await self.$store.dispatch('getUserAssessmentList', self.user.Id);
    },
    onFilter(e) {
      const self = this;
      e.preventDefault();
      const form = $(e.target);
      if (form.valid()) {
        const formData = {};
        $.map(form.serializeArray(), (item) => {
          Object.assign(formData, { [item.name]: item.value });
        });
        self.$store.commit('setUserAssessmentFilter', formData);
        self.initData();
      }
    },
  },
  watch: {
    userAssessmentList(e) {
      if (e) {
        Vue.set(this.$parent, 'userAssessmentCount', e.length);
      }
    },
  },
};
